(function () {
    angular
      .module('kareo.ui.shared.directives.k-enrl-payer-search', [
        'angucomplete-alt',
        'kareo.ui.shared.directives.state-codes',
        'kareo.ui.shared.modules.api.enrollments-service',
        'kareo.ui.shared.directives.k-focus-on',
        'kareo.ui.shared.directives.k-constants',
        'kareo.ui.shared.modules.data',
        'kareo.ui.shared.modules.featureSet'
      ])
      .directive('kEnrlPayerSearch', kEnrlPayerSearch)
      .run(['$templateCache', function ($templateCache) {
        $templateCache.put('./angucomplete-template.html', require('./angucomplete-template.pug')());
      }]);

    function kEnrlPayerSearch() {
      const directive = {
        bindToController: true,
        controller,
        controllerAs: 'vm',
        scope: {
          areFiltersVisible: '=?',
          payers: '=',
          practiceState: '=',
          duplicatePayerCheck: '<?',
          addedPayers: '<?',
          selectPayerCallback: '&',
          allowMultipleInsurances: '='
        },
        template: require('./k-enrl-payer-search.pug')()
      };

      return directive;
    }
      //----------------------
    controller.$inject = ['$filter', '$scope', '$rootScope', 'STATE_CODES', 'TRIZETTO_CLEARINGHOUSE_ID', 'JOPARI_CLEARINGHOUSE_ID', 'enrollmentsService', 'featureSet', 'practice'];
    function controller($filter, $scope, $rootScope, STATE_CODES, TRIZETTO_CLEARINGHOUSE_ID, JOPARI_CLEARINGHOUSE_ID, enrollmentsService, featureSet, practice) {
      const vm = this;

      vm.remoteUrlRequestFn = remoteUrlRequestFn;
      vm.inputChanged = inputChanged;
      vm.selectedPayer = selectedPayer;
      vm.toggleFilters = toggleFilters;
      vm.addCustomInsuranceCompany = addCustomInsuranceCompany;

      init();

      //----------------------

      function init() {
        initStates();

        featureSet.load().then((features) => {
          const hasWorkerCompClearinghouse = !!features['dark-feature.workers-comp-clearinghouse'];
          vm.isInsuranceAdmin = features['dark-feature.converged-insurance-admin'];
          vm.isAddInsuranceFeatureEnabled = features['dark-feature.enrollments-add-insurance'];
          enrollmentsService
          .getCustomerClearinghouses()
           .then((response) => {
             if (!hasWorkerCompClearinghouse) {
               vm.clearinghouseList = $filter('filter')(response, (clearinghouse) => clearinghouse.id !== JOPARI_CLEARINGHOUSE_ID);
             } else {
               vm.clearinghouseList = response;
             }

             vm.clearinghouseId = TRIZETTO_CLEARINGHOUSE_ID;
           });
        });

        practice.get().then((result) => {
          vm.isPmEnabled = result.pmenabled;
        });

        setFilterClasses();

        vm.focusSearch = false;
        vm.textNoResults = false;
        vm.clearinghouseId = 0;
      }

      function initStates() {
        const states = $filter('orderBy')(STATE_CODES, 'stateCode');
        const state = { stateCode: 'ALL' };
        states.unshift(state);

        vm.stateCode = vm.practiceState || state.stateCode;
        vm.states = states;
      }

      function inputChanged(str) {
        vm.searchStr = str;
      }

      function remoteUrlRequestFn(str) {
        const limit = 50;

        const state = vm.stateCode !== 'ALL' ? vm.stateCode : undefined;

        return {
          payerNameOrNumber: str,
          limit,
          claimType: vm.claimType,
          clearinghouseID: vm.clearinghouseId,
          stateSpecific: state
        };
      }

      function addCustomInsuranceCompany() {
        const customPayer = { name: vm.searchStr, isNewCustomCompany: true, isWithoutPayerId: true };
        if (vm.duplicatePayerCheck) {
          markDuplicatePayer(vm.payers, customPayer, 'name');
        }

        if(!vm.allowMultipleInsurances){
          vm.payers = [];
        }
        vm.payers.push(customPayer);
        $rootScope.$broadcast('showWithoutPayerIdAlert', customPayer);
        $scope.$broadcast('angucomplete-alt:clearInput');
        vm.searchStr = '';
      }

      function markDuplicatePayer(payerList, payer, field) {
        for (let index = 0; index < payerList.length; index++) {
          const listPayer = payerList[index];
          if (listPayer[field] === payer[field]) {
            payer.isDuplicate = true;
            break;
          }
        }
      }

      function selectedPayer(selected) {
        vm.focusSearch = true;
        vm.searchStr = '';
        if (selected) {
          if (vm.duplicatePayerCheck) {
            const newPayers = vm.addedPayers.concat(vm.payers);
            markDuplicatePayer(newPayers, selected.originalObject, 'payerNumber');
          }

          if(!vm.allowMultipleInsurances){
            vm.payers = [];
            vm.payers = [selected.originalObject];
          }
          else{
            vm.payers.push(selected.originalObject);
          }

          vm.selectPayerCallback({ 'payer': selected.originalObject });
        }
      }

      function setFilterClasses() {
        if (vm.areFiltersVisible) {
          vm.filterClass = 'show';
          vm.iconClass = 'ki caret';
        } else {
          vm.filterClass = 'hidden';
          vm.iconClass = 'ki caret-right';
        }
      }

      function toggleFilters() {
        vm.areFiltersVisible = !vm.areFiltersVisible;

        setFilterClasses();
      }
    }
  })();
